// 安卓版本列表
export const androidVersions = [
  { label: '安卓4及以下', value: 1650003 },
  { label: '安卓5', value: 1650004 },
  { label: '安卓6', value: 1650005 },
  { label: '安卓7', value: 1650006 },
  { label: '安卓8', value: 1650007 },
  { label: '安卓9', value: 1650008 },
  { label: '安卓10', value: 1650001 },
  { label: '安卓11', value: 1650002 },
  { label: '安卓12', value: 1650009 },
  { label: '安卓13', value: 1650010 },
  { label: '安卓14', value: 1650011 },
  { label: '安卓15', value: 1650012 },
  { label: '安卓16及以上', value: 1650013 }
]

// 购机价格列表
export const priceRanges = [
  { label: '>4500', value: 1530022 },
  { label: '4000~4500', value: 1530021 },
  { label: '3500~4000', value: 1530020 },
  { label: '3000~3500', value: 1530019 },
  { label: '2500~3000', value: 1530018 },
  { label: '2000~2500', value: 1530017 },
  { label: '1500~2000', value: 1530016 },
  { label: '1000~1500', value: 1530015 },
  { label: '0~1000', value: 1530014 }
]

// 展现形式列表
export const displayTypeOptions = [
  {
    value: '1',
    label: '信息流',
    children: [
      { value: '62', label: '横板大图' },
      { value: '63', label: '竖版大图' },
      { value: '4', label: '组图' },
      { value: '3', label: '小图' },
      { value: '61', label: '横板视频' },
      { value: '75', label: '竖版视频' }
    ]
  },
  {
    value: '6',
    label: '锁屏壁纸',
    children: [
      { value: '64', label: '竖版图片' },
      { value: '4', label: '组图' },
      { value: '75', label: '竖版视频' }
    ]
  },
  {
    value: '2',
    label: '开屏',
    children: [
      { value: '35', label: '竖版大图（1080*1880）' },
      { value: '85', label: '横版大图' },
      { value: '213', label: '竖版大图（1080*1920）' }
    ]
  },
  {
    value: '5',
    label: '原生广告',
    children: [
      { value: '48', label: '横板大图' },
      { value: '209', label: '竖版大图' },
      { value: '4', label: '组图' },
      { value: '121', label: '小图' },
      { value: '242', label: '竖版视频' },
      { value: '122', label: '横版视频' }
    ]
  },
  {
    value: '4',
    label: '插屏',
    children: [
      { value: '39', label: '竖版大图(780*800)' },
      { value: '208', label: '横版大图(1280*720)' },
      { value: '145', label: '竖版视频(720*1280)' },
      { value: '142', label: '横版视频(1280*720)' }
    ]
  },
  {
    value: '20',
    label: '推荐列表',
    children: [
      { value: '0', label: '无' },
      { value: '3', label: '搜索三图' },
      { value: '4', label: '动态icon' },
      { value: '5', label: '顶部banner' },
      { value: '14', label: '挂件' },
      { value: '15', label: '标签气泡' },
      { value: '16', label: '高亮一句话' },
      { value: '18', label: '智能秒装' },
      { value: '19', label: '列表背景' }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/components/vivo/vivopda/constants.js